import { render, staticRenderFns } from "./IFramePage.vue?vue&type=template&id=6bd545d5&scoped=true"
import script from "./IFramePage.vue?vue&type=script&lang=ts"
export * from "./IFramePage.vue?vue&type=script&lang=ts"
import style0 from "./IFramePage.vue?vue&type=style&index=0&id=6bd545d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd545d5",
  null
  
)

export default component.exports